import { commerce } from './lib/commerce';
import React, { useState, useEffect } from 'react';
import './App.css';
import {Navbar,Products,Cart,Checkout} from './components';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

function App() {
  const [products, setProducts] = useState([]);
  const [cart, setCart] = useState({});
  const [order, setOrder] = useState({});
  const [errorMessage, setErrorMessage] = useState('');

  const fetchProducts = async () => {
    const { data } = await commerce.products.list();
    setProducts(data)
  }
  const fetchCart = async () => {
    setCart(await commerce.cart.retrieve());
  };

  const handleAddToCart = async (productId, quantity) => {
    const {cart} = await commerce.cart.add(productId, quantity);

    setCart( cart);
  };
  const handleUpdateCartQty = async (lineItemId, quantity) => {
    const {cart}= await commerce.cart.update(lineItemId, { quantity });

    setCart(cart);
  };
  const handleRemoveFromCart = async (lineItemId) => {
    const {cart} = await commerce.cart.remove(lineItemId);

    setCart(cart);
  };
  const handleEmptyCart = async () => {
    const {cart} = await commerce.cart.empty();

    setCart(cart);
  };
  const refreshCart = async () => {
    const newCart = await commerce.cart.refresh();

    setCart(newCart);
  };

  const handleCaptureCheckout = async (checkoutTokenId, newOrder) => {
    try {
      const incomingOrder = await commerce.checkout.capture(checkoutTokenId, newOrder);

      setOrder(incomingOrder);

      refreshCart();
    } catch (error) {
      setErrorMessage(error.data.error.message);
    }
  };

  useEffect(()=>{
    fetchProducts()
    fetchCart()
  },[])
  console.log(cart)
    


  return (
    <Router>
      <div className="App">
        
        <Navbar totalItems={cart.total_items}/>
        <Routes>
          <Route exact path="/" element={<Products products={products} onAddToCart={handleAddToCart}/>}>
          </Route>
          
          <Route exact path="/cart" element={<Cart cart={cart} onUpdateCartQty={handleUpdateCartQty} onRemoveFromCart={handleRemoveFromCart} onEmptyCart={handleEmptyCart}/>}>
          </Route>
          <Route exact path="/checkout" element={<Checkout cart={cart}  order={order} onCaptureCheckout={handleCaptureCheckout} error={errorMessage} />}>
          </Route>
          
          
        </Routes>
      </div>
    </Router>
    

  );
}

export default App;
